import { LEAGUE_TZ } from '@region13/shared-types'

// Shared date helper for practice-slot displays (Home summary row +
// PracticeSlotCard's full card). One copy so a fix to the UTC-noon parse
// never has to be made twice.

/** 'YYYY-MM-DD' -> "Oct 15", parsed at UTC noon.
 *
 *  ⚠️ A PASSTHROUGH. The rule moved to `@region13/shared-types` when the stats
 *  SPA's Missing Cards filter needed the same short date, rather than becoming
 *  a second copy. It is named `wallClockDayLabel` there to keep it apart from
 *  admin-spa's and apps/workers' `shortDate`, which formats a real TIMESTAMP
 *  in the league time zone. The local name stays because this app's practice
 *  screens reach for it by this path; it must never grow a rule of its own. */
export { wallClockDayLabel as shortDate } from '@region13/shared-types'

/** The league's IANA time zone (`seasons.time_zone` defaults to this).
 *  Anything formatting a real timestamp (not just a wall-clock
 *  'YYYY-MM-DD') for a coach must go through this, not the browser's local
 *  zone: a coach reading their own submission time needs the league's day,
 *  not whatever day their device happens to sit in.
 *  The value is `@region13/shared-types`' `LEAGUE_TZ` (#799). */
export const DEFAULT_LEAGUE_TZ = LEAGUE_TZ
